import React from 'react';
import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import BookDemoButton from '@/dataroom/ui/common/BookDemoButton';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import baseStyles from '../tenant17g5Styles.module.scss';
import styles from './learnMore.module.scss';

interface IProps {
  title?: string,
  description?: string,
}

const LearnMore = ({
  title = 'Ready to learn more?',
  description = `Get a quote or schedule a demo with a product specialist who can address your
                 questions and show you the platform.`,
}: IProps) => (
  <div className={ styles.learnMoreContainer }>
    <div className={ styles.learnMoreDescription }>
      <div className={ baseStyles.sectionTitle }>{ title }</div>
      <div className={ baseStyles.sectionDescription }>
        { description }
      </div>
    </div>
    <div className={ styles.learnMoreButtons } data-test="learnMoreButtons">
      <BookDemoButton legacy className={ baseStyles.secondaryBtn } />
      <NextNavLink
        to="/get-a-quote"
        dataTest="getAQuote"
      >
        <Button
          variant={ ButtonVariantType.action }
          className={ spacesStyles.mrn }
          title="Get a Quote"
          dataTest="getAQuoteButton"
        />
      </NextNavLink>
    </div>
  </div>
);

export default LearnMore;
